import * as React from 'react'

const HeartIcon = (props: { foreground: React.SVGProps<SVGPathElement>['fill'] }) => (
  <div style={{ width: 24, height: 24 }}>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M13.009 7.614h0l.001-.001.006-.005.023-.02a41.908 41.908 0 01.415-.368c.27-.236.618-.531.946-.792 1.634-1.296 3.685-1.22 5.042.136 1.36 1.36 1.475 3.778-.042 5.422-.972 1.053-2.753 2.762-4.44 4.207-.843.722-1.634 1.354-2.27 1.796a7.671 7.671 0 01-.69.438 7.676 7.676 0 01-.691-.438c-.637-.443-1.429-1.075-2.272-1.797-1.687-1.444-3.468-3.153-4.438-4.205-1.515-1.645-1.401-4.064-.042-5.423 1.357-1.357 3.41-1.432 5.045-.136a28.004 28.004 0 011.271 1.078l.09.081.024.02.005.006h.001v.001h0l1.008.914 1.008-.914h0zm-1.223 10.915h.003a.056.056 0 01-.003 0zm.426 0h0z"
        stroke={props.foreground}
        strokeWidth="3"
      />
    </svg>
  </div>
)

export default HeartIcon
